import PropTypes from 'prop-types';
import React from 'react';
import { get } from 'ctm-util-functions';
import { Anchor } from '../anchor/anchor';
import style from './product_suitability.css';

/**
 * The product suitability component - with a configurable label, variant, and terms modal button
 * productSuitability within the product object will look like the following:
 * productSuitability: string
 * @param {Object} props The properties
 * @param {Object} props.visualProps A variant to display alternate styles (schema defined)
 * @param {Object} props.contentProps A label
 * @param {Object} props.stateProps - The stateful product object passed in via container
 * @returns {Node} The special offer component
 * @constructor
 */
const ProductSuitability = ({ visualProps = {}, contentProps = {}, stateProps }) => {
    const { stateKey } = contentProps;
    const { variant = 'default' } = visualProps;
    const productSuitabilityData = get(stateProps, stateKey);
    const { product } = stateProps;

    return productSuitabilityData ? (
        <div className={style[variant]} data-balanceheight={'productSuitability'}>
            <Anchor href={product.getIn(['productMeta', 'productSuitability'])} target="_blank">
                Is this product suitable for me?
            </Anchor>
        </div>
    ) : <div className={style[`${variant}_placeholder`]} />;
};

ProductSuitability.propTypes = {
    contentProps: PropTypes.shape({
        stateKey: PropTypes.string
    }),
    stateProps: PropTypes.shape({
        product: PropTypes.object
    }),
    modalProps: PropTypes.shape({
        openComponent: PropTypes.array,
        stateProps: PropTypes.object
    }),
    visualProps: PropTypes.shape({
        variant: PropTypes.string
    })
};

export { ProductSuitability };
